// extracted by mini-css-extract-plugin
export var avatarContainer = "_gx-0";
export var avatarTypingWave = "_gx-i";
export var gray = "_gx-f";
export var green = "_gx-c";
export var icon = "_gx-9";
export var image = "_gx-1";
export var lg = "_gx-6";
export var md = "_gx-5";
export var presenceDot = "_gx-b";
export var red = "_gx-d";
export var sm = "_gx-4";
export var status = "_gx-a";
export var typingDot = "_gx-h";
export var typingPill = "_gx-g";
export var xl = "_gx-7";
export var xs = "_gx-3";
export var xxl = "_gx-8";
export var xxs = "_gx-2";
export var yellow = "_gx-e";